import React from "react";
import { Box, Typography } from "@mui/material";
import MyContainer from "../../../MyContainer";
import ProductCard from "../../../ui/ProductCard";
import { useRelatedProductsSectionStyles } from "./RelatedProductsSection.styles";
import { useI18n } from "../../../../i8n/useI18n";
import { useCommerceData } from "../../../../hooks/useCommerceData";
import { commerceRepository } from "../../../../api";

interface RelatedProductsSectionProps {
    handle: string;
}

const RelatedProductsSection = (props: RelatedProductsSectionProps) => {
    const { classes } = useRelatedProductsSectionStyles();
    const { t } = useI18n();
    const { data } = useCommerceData(() => commerceRepository.getRelatedProducts(props.handle, 4), [props.handle]);

    if (!data || data.length === 0) {
        return null;
    }

    return (
        <Box className={classes.root}>
            <MyContainer>
                <Typography variant="h2" className={classes.title}>{t("productPage.relatedTitle")}</Typography>
                <Box className={classes.grid}>
                    {data.map((product) => (
                        <ProductCard key={product.id} product={product} />
                    ))}
                </Box>
            </MyContainer>
        </Box>
    );
};

export default RelatedProductsSection;
